import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import common from "./modules/common";
import user from "./modules/user";
import consult from "./modules/consult";
import course from "./modules/course";
import permission from "./modules/permission";
import questionnaire from "./modules/questionnaire";
import activity from "./modules/activity";
import audit from "./modules/audit";
import socket from "./modules/socket";

Vue.use(Vuex);

export default new Vuex.Store({
  getters: {},
  modules: {
    common,
    user,
    consult,
    course,
    permission,
    questionnaire,
    activity,
    audit,
    socket,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        "common",
        "user",
        "consult",
        "course",
        "questionnaire",
        "activity",
        "audit",
      ],
    }),
  ],
});
